import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-question-line text-3xl"></i>
        </span>
        <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
          这个页面走丢了
        </h1>
        <p className="mt-3 font-label text-sm text-foreground-600">
          你访问的地址没有对应的内容：
        </p>
        <p className="mt-2 rounded-md bg-background-100 px-4 py-2 font-label text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            回到首页
          </Link>
          <Link
            to="/list"
            className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-fire-line"></i>
            浏览大瓜合集
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}